export interface NewsArticle {
  id: string;
  title: string;
  category: string;
  date: string;
  author: string;
  cover: string;
  summary: string;
  paragraphs: string[];
  relatedIds: string[];
}

export const news: NewsArticle[] = [
  {
    id: 'n1',
    title: '《星际远征》幕后揭秘：一场用真空气球拍摄的失重戏',
    category: '幕后制作',
    date: '2025-09-28',
    author: '特稿组 · 林知远',
    cover: 'https://readdy.ai/api/search-image?query=behind%20the%20scenes%20of%20a%20sci-fi%20film%20set%20with%20large%20practical%20lighting%20rigs%20and%20space%20station%20sets%2C%20cool%20blue%20tones%20with%20warm%20accents%2C%20cinematic%20documentary%20look&width=1200&height=675&seq=kh-news-n1&orientation=landscape',
    summary: '为了拍出真正令人信服的失重感，剧组放弃了绿幕，改用一个直径三十米的充气穹顶，把演员“吊”进了一个可以旋转的密闭空间。',
    paragraphs: [
      '走进《星际远征》位于郊外的摄影棚，最先看到的不是绿幕，而是一个巨大的半透明充气穹顶。导演陈星河告诉我们，为了让观众相信“失重”，剧组放弃了后期合成的捷径，转而用大量实体道具与机械结构去还原真实的物理感。',
      '“演员在绿幕前表演失重，永远是在想象。这次我们让他们真的漂浮起来。”摄影指导介绍，穹顶内部布置了可旋转的环状支架，配合特制的气球配重系统，演员只需专注表演，而不用时刻对抗威亚的不自然拉力。',
      '最耗时的是一场长达六分钟的舱内危机戏。为了控制光线在密闭空间里的反射，灯光组把每一盏灯都做了哑光处理，甚至给飞船的金属面板重新刷上了吸光涂层。这场戏最终拍摄了整整十一天。',
      '当被问到这样做是否“性价比太低”时，陈星河笑了笑：“观众会记住的那几秒钟，往往就是我们花最多时间的地方。”影片目前正在院线热映。',
    ],
    relatedIds: ['n2', 'n4'],
  },
  {
    id: 'n2',
    title: '2025 年度观影指南：这八部作品值得你留出一个周末',
    category: '观影指南',
    date: '2025-09-20',
    author: '编辑部 · 苏吟',
    cover: 'https://readdy.ai/api/search-image?query=cozy%20weekend%20movie%20night%20scene%20with%20a%20projector%20casting%20warm%20light%20and%20popcorn%20on%20a%20wooden%20table%2C%20warm%20amber%20tones%2C%20inviting%20atmosphere&width=1200&height=675&seq=kh-news-n2&orientation=landscape',
    summary: '从硬科幻到家庭剧，我们按“陪你度过一个完整周末”的标准，挑了八部节奏、情绪各不相同却都足够扎实的作品。',
    paragraphs: [
      '挑选片单这件事，最怕的就是“什么都想要”。所以这次我们换了个标准：如果只有一个完整的周末，你最想怎么过？',
      '周五晚上适合开场一部视觉型作品，《星际远征》的沉浸感能让一周的疲惫快速清空。周六下午可以留给《长安夜行》，抽丝剥茧的探案节奏刚好配一杯茶。',
      '如果你更想被情绪接住，那就把《城市之光》和《家有暖阳》放进周日的播放列表。前者锋利，后者柔软，正好凑成一天的两面。',
      '当然，这只是我们的一己之见。真正好的片单，从来都是一次次点开、一次次重来的结果。',
    ],
    relatedIds: ['n5', 'n3'],
  },
  {
    id: 'n3',
    title: '从“神都”到“洛阳”：古装探案剧的美术如何重建一座城',
    category: '行业观察',
    date: '2025-09-12',
    author: '特稿组 · 顾南',
    cover: 'https://readdy.ai/api/search-image?query=detailed%20ancient%20Chinese%20city%20miniature%20model%20with%20lanterns%20and%20wooden%20architecture%20in%20a%20warm%20studio%20light%2C%20craftsmanship%20documentary%20style&width=1200&height=675&seq=kh-news-n3&orientation=landscape',
    summary: '《风起洛阳》的美术团队用一年半时间考据了三百多张图纸，只为让镜头扫过街市时，每一块招牌都站得住脚。',
    paragraphs: [
      '在大多数观众的记忆里，古装剧的“城”往往是模糊的背景板。但《风起洛阳》的美术团队显然不这么想。',
      '美术指导高翎介绍，团队花了整整一年半时间，查阅了大量出土文物、壁画与文献，仅市集街区的布局方案就推翻重做了七稿。“观众未必认得出我们考据了什么，但一旦有地方不对，气氛就散了。”',
      '为了还原夜晚灯火的效果，剧组没有依赖后期加光，而是定制了两万余盏不同规格的灯笼，由灯光组逐盏布置色温。一场长街夜戏，光是布灯就用了两天。',
      '“我们想做的不是‘像’，而是‘在’。”高翎说，“让观众觉得自己真的站在那条街上，风从耳边吹过去。”',
    ],
    relatedIds: ['n1', 'n6'],
  },
  {
    id: 'n4',
    title: '为什么我们越来越爱看“慢”下来的科幻',
    category: '行业观察',
    date: '2025-09-05',
    author: '编辑部 · 沈砚',
    cover: 'https://readdy.ai/api/search-image?query=contemplative%20sci-fi%20scene%20of%20an%20astronaut%20sitting%20calmly%20by%20a%20space%20station%20window%20looking%20at%20stars%2C%20quiet%20blue%20tones%2C%20serene%20cinematic%20mood&width=1200&height=675&seq=kh-news-n4&orientation=landscape',
    summary: '当爆炸和特效不再稀缺，真正打动人的，反而是那些愿意慢下来、把镜头对准孤独与人心的科幻作品。',
    paragraphs: [
      '过去的科幻大片，比拼的是“更大的场面”。但近两年的高分作品里，越来越多的镜头留给了安静的时刻。',
      '《星海守望》里，主角伊莱有一半的时间都在对着通讯器自言自语。没有敌人，没有战斗，只有回声。恰恰是这种克制，让“孤独”这个主题变得可以触摸。',
      '这种转向并非偶然。当特效门槛下降，观众对“奇观”的耐受度反而更高。创作者开始意识到，科幻的尽头未必是视觉，而是把人放进一个极端环境后，逼问出来的那些问题。',
      '或许这正是“慢科幻”迷人的地方：它不急着给你答案，而是陪你多坐一会儿。',
    ],
    relatedIds: ['n1', 'n5'],
  },
  {
    id: 'n5',
    title: '韩剧《时光信箱》凭什么让观众看哭了三轮',
    category: '影视评论',
    date: '2025-08-29',
    author: '评论组 · 温知夏',
    cover: 'https://readdy.ai/api/search-image?query=vintage%20iron%20mailbox%20in%20a%20quiet%20park%20at%20golden%20sunset%20with%20autumn%20leaves%2C%20warm%20nostalgic%20tones%2C%20gentle%20romantic%20mood&width=1200&height=675&seq=kh-news-n5&orientation=landscape',
    summary: '没有大场面，没有反转王炸，《时光信箱》靠的只是两个人认认真真地写信。',
    paragraphs: [
      '如果只看设定，《时光信箱》其实很“小”：一个能寄信到过去的信箱，两个隔着二十年通信的陌生人。',
      '但真正让观众流泪的，是信里的那些琐碎。他写今天的雨、写母亲的抱怨、写自己不敢说出口的喜欢；她写未来的城市、写失去的人、写“你要好好活着”。',
      '导演朴敏贞在一次访谈里说，她最想拍的是“被认真对待的情感”。在这个消息秒回的时代，等待一封信的漫长，本身就是一种浪漫。',
      '所以它催泪，不是因为剧情感人，而是因为它提醒我们：有些话，值得慢慢写。',
    ],
    relatedIds: ['n2', 'n4'],
  },
  {
    id: 'n6',
    title: '家庭剧的“烟火气”：为什么一顿饭的戏最难拍',
    category: '幕后制作',
    date: '2025-08-22',
    author: '特稿组 · 林知远',
    cover: 'https://readdy.ai/api/search-image?query=warm%20home%20kitchen%20scene%20with%20steaming%20home%20cooked%20dishes%20on%20a%20table%20under%20soft%20afternoon%20light%2C%20cozy%20amber%20tones%2C%20documentary%20feel&width=1200&height=675&seq=kh-news-n6&orientation=landscape',
    summary: '《家有暖阳》的现场有一条不成文的规定：饭桌上的菜，必须是真的热的。',
    paragraphs: [
      '拍一顿家常饭，听上去再简单不过。但《家有暖阳》的现场，往往要为一桌菜耗上大半天。',
      '导演周慧兰坚持认为，热气是家庭戏的“呼吸”。为此，剧组配备了专门的餐食组，每拍一条就重新上一轮刚出锅的菜，确保镜头里的汤还在冒烟。',
      '更难的是 timing。一家人边吃边聊，谁先动筷子、谁先叹气、语速快慢，都要卡在生活化的节奏里。演员们常常在开拍前先真吃上十分钟，找回状态。',
      '“观众不会去分析你怎么拍，”周慧兰说，“他们只知道，那一刻，闻起来像家。”',
    ],
    relatedIds: ['n3', 'n5'],
  },
  {
    id: 'n7',
    title: '放映厅重新热闹起来了：实体影院的复兴观察',
    category: '行业观察',
    date: '2025-08-15',
    author: '编辑部 · 沈砚',
    cover: 'https://readdy.ai/api/search-image?query=exterior%20of%20a%20modern%20cinema%20entrance%20at%20dusk%20with%20marquee%20lights%20and%20a%20few%20people%20walking%20in%2C%20warm%20cinematic%20glow%2C%20urban%20night%20atmosphere&width=1200&height=675&seq=kh-news-n7&orientation=landscape',
    summary: '在流媒体竞争最激烈的这几年，越来越多的观众反而重新坐回了黑暗的放映厅里。',
    paragraphs: [
      '过去大家常说，流媒体会“杀死”影院。但最新的数据里，反而出现了另一个趋势：愿意为一次线下观影专门腾出时间的人，越来越多了。',
      '影院的变化是关键。不少场次开始提供更舒适的座椅、更好的音响，以及映后的主创交流。观影从“随便看看”变成了“值得计划的一件事”。',
      '有观众在采访里说得很直白：“在家我永远会分心去拿手机。但在影院，我只能专心看这一部。”',
      '也许影院真正卖的不是内容，而是一段不被打扰的时间。',
    ],
    relatedIds: ['n4', 'n2'],
  },
  {
    id: 'n8',
    title: '新人指南：第一次写影评，从记住一个镜头开始',
    category: '观影指南',
    date: '2025-08-08',
    author: '评论组 · 温知夏',
    cover: 'https://readdy.ai/api/search-image?query=open%20notebook%20with%20handwriting%20and%20a%20cup%20of%20coffee%20next%20to%20a%20warm%20lamp%2C%20soft%20evening%20light%2C%20cozy%20writing%20atmosphere&width=1200&height=675&seq=kh-news-n8&orientation=landscape',
    summary: '影评不是范文，也不需要通过考试。你只需要诚实地写下，哪个画面让你停了半秒。',
    paragraphs: [
      '很多人不敢写影评，是因为觉得“看不懂”。但影评的门槛其实没有想象中那么高。',
      '最实用的起点，是记住一个具体的镜头。不必是高潮，可能只是一个转身、一次沉默，甚至一件道具。先把它描述清楚，再问自己：为什么是这个画面留住了我？',
      '接下来，试着找出这个镜头和整部片子的关系。它是情绪的中点，还是主题的隐喻？这一步不需要“对”，只需要你自己的解释。',
      '最后，别怕写得短。真诚的一百字，远比堆砌术语的一千字更值得读。',
    ],
    relatedIds: ['n2', 'n5'],
  },
];